export const iconLoaders = {
  AdultBd: () => import('./AdultBd'),
  AdultFilled: () => import('./AdultFilled'),
  AdultMd: () => import('./AdultMd'),
  AdultOutlinedLt: () => import('./AdultOutlinedLt'),
  AiFilled: () => import('./AiFilled'),
  AlarmOffBd: () => import('./AlarmOffBd'),
  AlarmOffLt: () => import('./AlarmOffLt'),
  AlarmOffMd: () => import('./AlarmOffMd'),
  AlarmOnBd: () => import('./AlarmOnBd'),
  AlarmOnLt: () => import('./AlarmOnLt'),
  AlarmOnMd: () => import('./AlarmOnMd'),
  AlmostEqualFilled: () => import('./AlmostEqualFilled'),
  ArrowDownBd: () => import('./ArrowDownBd'),
  ArrowDownLt: () => import('./ArrowDownLt'),
  ArrowDownMd: () => import('./ArrowDownMd'),
  ArrowLeftBd: () => import('./ArrowLeftBd'),
  ArrowLeftLt: () => import('./ArrowLeftLt'),
  ArrowLeftMd: () => import('./ArrowLeftMd'),
  ArrowRightBd: () => import('./ArrowRightBd'),
  ArrowRightLt: () => import('./ArrowRightLt'),
  ArrowRightMd: () => import('./ArrowRightMd'),
  ArrowRightUpBd: () => import('./ArrowRightUpBd'),
  ArrowRightUpLt: () => import('./ArrowRightUpLt'),
  ArrowRightUpMd: () => import('./ArrowRightUpMd'),
  ArrowUpBd: () => import('./ArrowUpBd'),
  ArrowUpLt: () => import('./ArrowUpLt'),
  ArrowUpMd: () => import('./ArrowUpMd'),
  BjNoticeOffBd: () => import('./BjNoticeOffBd'),
  BjNoticeOffLt: () => import('./BjNoticeOffLt'),
  BjNoticeOffMd: () => import('./BjNoticeOffMd'),
  BjNoticeOnBd: () => import('./BjNoticeOnBd'),
  BjNoticeOnLt: () => import('./BjNoticeOnLt'),
  BjNoticeOnMd: () => import('./BjNoticeOnMd'),
  BookmarkBd: () => import('./BookmarkBd'),
  BookmarkFilled: () => import('./BookmarkFilled'),
  BookmarkLt: () => import('./BookmarkLt'),
  BookmarkMd: () => import('./BookmarkMd'),
  CalanderLt: () => import('./CalanderLt'),
  CalanderMd: () => import('./CalanderMd'),
  CalendarBd: () => import('./CalendarBd'),
  CalendarLt: () => import('./CalendarLt'),
  CalendarMd: () => import('./CalendarMd'),
  CameraFilled: () => import('./CameraFilled'),
  CastOffBd: () => import('./CastOffBd'),
  CastOffLt: () => import('./CastOffLt'),
  CastOffMd: () => import('./CastOffMd'),
  CastOnBd: () => import('./CastOnBd'),
  CastOnLt: () => import('./CastOnLt'),
  CastOnMd: () => import('./CastOnMd'),
  ChatBd: () => import('./ChatBd'),
  ChatFilled: () => import('./ChatFilled'),
  ChatLt: () => import('./ChatLt'),
  ChatMd: () => import('./ChatMd'),
  ChatOffFilled: () => import('./ChatOffFilled'),
  CheckBd: () => import('./CheckBd'),
  CheckLt: () => import('./CheckLt'),
  CheckMd: () => import('./CheckMd'),
  Checked: () => import('./Checked'),
  ChevronArrowDownBd: () => import('./ChevronArrowDownBd'),
  ChevronArrowDownLt: () => import('./ChevronArrowDownLt'),
  ChevronArrowDownMd: () => import('./ChevronArrowDownMd'),
  ChevronArrowLeftBd: () => import('./ChevronArrowLeftBd'),
  ChevronArrowLeftLt: () => import('./ChevronArrowLeftLt'),
  ChevronArrowLeftMd: () => import('./ChevronArrowLeftMd'),
  ChevronArrowRightBd: () => import('./ChevronArrowRightBd'),
  ChevronArrowRightLt: () => import('./ChevronArrowRightLt'),
  ChevronArrowRightMd: () => import('./ChevronArrowRightMd'),
  ChevronArrowUpBd: () => import('./ChevronArrowUpBd'),
  ChevronArrowUpLt: () => import('./ChevronArrowUpLt'),
  ChevronArrowUpMd: () => import('./ChevronArrowUpMd'),
  Class19: () => import('./Class19'),
  ClassAssistant: () => import('./ClassAssistant'),
  ClassB: () => import('./ClassB'),
  ClassBj: () => import('./ClassBj'),
  ClassC: () => import('./ClassC'),
  ClassD: () => import('./ClassD'),
  ClassG: () => import('./ClassG'),
  ClassM: () => import('./ClassM'),
  ClassMoneyW: () => import('./ClassMoneyW'),
  ClassMoneyY: () => import('./ClassMoneyY'),
  ClassN: () => import('./ClassN'),
  ClassNew: () => import('./ClassNew'),
  ClassPolice: () => import('./ClassPolice'),
  ClassS: () => import('./ClassS'),
  ClassSuppoter: () => import('./ClassSuppoter'),
  ClassV: () => import('./ClassV'),
  CloseBd: () => import('./CloseBd'),
  CloseFilled: () => import('./CloseFilled'),
  CloseLt: () => import('./CloseLt'),
  CloseMd: () => import('./CloseMd'),
  ConfirmedFilled: () => import('./ConfirmedFilled'),
  ContactBd: () => import('./ContactBd'),
  ContactFilled: () => import('./ContactFilled'),
  ContactLt: () => import('./ContactLt'),
  ContactMd: () => import('./ContactMd'),
  ContentListBd: () => import('./ContentListBd'),
  ContentListLt: () => import('./ContentListLt'),
  ContentListMd: () => import('./ContentListMd'),
  CopyBd: () => import('./CopyBd'),
  CopyLt: () => import('./CopyLt'),
  CopyMd: () => import('./CopyMd'),
  CricleBd: () => import('./CricleBd'),
  CricleCheckBd: () => import('./CricleCheckBd'),
  CricleCheckLt: () => import('./CricleCheckLt'),
  CricleCheckMd: () => import('./CricleCheckMd'),
  CricleCloseBd: () => import('./CricleCloseBd'),
  CricleCloseLt: () => import('./CricleCloseLt'),
  CricleCloseMd: () => import('./CricleCloseMd'),
  CricleLt: () => import('./CricleLt'),
  CricleMd: () => import('./CricleMd'),
  CricleMinusBd: () => import('./CricleMinusBd'),
  CricleMinusLt: () => import('./CricleMinusLt'),
  CricleMinusMd: () => import('./CricleMinusMd'),
  CriclePlusBd: () => import('./CriclePlusBd'),
  CriclePlusLt: () => import('./CriclePlusLt'),
  CriclePlusMd: () => import('./CriclePlusMd'),
  CricleQaBd: () => import('./CricleQaBd'),
  CricleQaFilled: () => import('./CricleQaFilled'),
  CricleQaLt: () => import('./CricleQaLt'),
  CricleQaMd: () => import('./CricleQaMd'),
  CricleWarningBd: () => import('./CricleWarningBd'),
  CricleWarningLt: () => import('./CricleWarningLt'),
  CricleWarningMd: () => import('./CricleWarningMd'),
  DarkBd: () => import('./DarkBd'),
  DarkLt: () => import('./DarkLt'),
  DarkMd: () => import('./DarkMd'),
  DeleteBd: () => import('./DeleteBd'),
  DeleteLt: () => import('./DeleteLt'),
  DeleteMd: () => import('./DeleteMd'),
  Determinate: () => import('./Determinate'),
  DmOffBd: () => import('./DmOffBd'),
  DmOffLt: () => import('./DmOffLt'),
  DmOffMd: () => import('./DmOffMd'),
  DmOnBd: () => import('./DmOnBd'),
  DmOnLt: () => import('./DmOnLt'),
  DmOnMd: () => import('./DmOnMd'),
  DoubleArrowDownBd: () => import('./DoubleArrowDownBd'),
  DoubleArrowDownLt: () => import('./DoubleArrowDownLt'),
  DoubleArrowDownMd: () => import('./DoubleArrowDownMd'),
  DoubleArrowLeftBd: () => import('./DoubleArrowLeftBd'),
  DoubleArrowLeftLt: () => import('./DoubleArrowLeftLt'),
  DoubleArrowLeftMd: () => import('./DoubleArrowLeftMd'),
  DoubleArrowRightBd: () => import('./DoubleArrowRightBd'),
  DoubleArrowRightLt: () => import('./DoubleArrowRightLt'),
  DoubleArrowRightMd: () => import('./DoubleArrowRightMd'),
  DownloadBd: () => import('./DownloadBd'),
  DownloadLt: () => import('./DownloadLt'),
  DownloadMd: () => import('./DownloadMd'),
  EditBd: () => import('./EditBd'),
  EditFilled: () => import('./EditFilled'),
  EditLt: () => import('./EditLt'),
  EditMd: () => import('./EditMd'),
  EmojiBd: () => import('./EmojiBd'),
  EmojiLt: () => import('./EmojiLt'),
  EmojiMd: () => import('./EmojiMd'),
  ErrorFilled: () => import('./ErrorFilled'),
  EventBd: () => import('./EventBd'),
  EventLt: () => import('./EventLt'),
  EventMd: () => import('./EventMd'),
  FanRanking01: () => import('./FanRanking01'),
  FanRanking02: () => import('./FanRanking02'),
  FanRanking03: () => import('./FanRanking03'),
  FemaleBd: () => import('./FemaleBd'),
  FemaleLt: () => import('./FemaleLt'),
  FemaleMd: () => import('./FemaleMd'),
  FoldLeftBd: () => import('./FoldLeftBd'),
  FoldLeftLt: () => import('./FoldLeftLt'),
  FoldLeftMd: () => import('./FoldLeftMd'),
  FoldRightBd: () => import('./FoldRightBd'),
  FoldRightLt: () => import('./FoldRightLt'),
  FoldRightMd: () => import('./FoldRightMd'),
  FolderBd: () => import('./FolderBd'),
  FolderLt: () => import('./FolderLt'),
  FolderMd: () => import('./FolderMd'),
  ForwardingFilled: () => import('./ForwardingFilled'),
  FreeHeartBd: () => import('./FreeHeartBd'),
  FreeHeartLt: () => import('./FreeHeartLt'),
  FreeHeartMd: () => import('./FreeHeartMd'),
  FullscreenBd: () => import('./FullscreenBd'),
  FullscreenExitBd: () => import('./FullscreenExitBd'),
  FullscreenExitLt: () => import('./FullscreenExitLt'),
  FullscreenExitMd: () => import('./FullscreenExitMd'),
  FullscreenLt: () => import('./FullscreenLt'),
  FullscreenMd: () => import('./FullscreenMd'),
  GiftBd: () => import('./GiftBd'),
  GiftLt: () => import('./GiftLt'),
  GiftMd: () => import('./GiftMd'),
  HamburgerBd: () => import('./HamburgerBd'),
  HamburgerLt: () => import('./HamburgerLt'),
  HamburgerMd: () => import('./HamburgerMd'),
  HeartBd: () => import('./HeartBd'),
  HeartFilled: () => import('./HeartFilled'),
  HeartHistoryBd: () => import('./HeartHistoryBd'),
  HeartHistoryLt: () => import('./HeartHistoryLt'),
  HeartHistoryMd: () => import('./HeartHistoryMd'),
  HeartLt: () => import('./HeartLt'),
  HeartMd: () => import('./HeartMd'),
  HomeBd: () => import('./HomeBd'),
  HomeFilled: () => import('./HomeFilled'),
  HomeLt: () => import('./HomeLt'),
  HomeMd: () => import('./HomeMd'),
  ImageBd: () => import('./ImageBd'),
  ImageLt: () => import('./ImageLt'),
  ImageMd: () => import('./ImageMd'),
  JpFontSizeLFilled: () => import('./JpFontSizeLFilled'),
  JpFontSizeMFilled: () => import('./JpFontSizeMFilled'),
  JpFontSizeSFilled: () => import('./JpFontSizeSFilled'),
  KeyboardBd: () => import('./KeyboardBd'),
  KeyboardLt: () => import('./KeyboardLt'),
  KeyboardMd: () => import('./KeyboardMd'),
  KingFan: () => import('./KingFan'),
  LightBd: () => import('./LightBd'),
  LightLt: () => import('./LightLt'),
  LightMd: () => import('./LightMd'),
  LikeBd: () => import('./LikeBd'),
  LikeFilled: () => import('./LikeFilled'),
  LikeLt: () => import('./LikeLt'),
  LikeMd: () => import('./LikeMd'),
  ListBd: () => import('./ListBd'),
  ListLt: () => import('./ListLt'),
  ListMd: () => import('./ListMd'),
  LiveBd: () => import('./LiveBd'),
  LiveFilled: () => import('./LiveFilled'),
  LiveLt: () => import('./LiveLt'),
  LiveMd: () => import('./LiveMd'),
  LockFilled: () => import('./LockFilled'),
  LogoutBd: () => import('./LogoutBd'),
  LogoutLt: () => import('./LogoutLt'),
  LogoutMd: () => import('./LogoutMd'),
  MaleBd: () => import('./MaleBd'),
  MaleLt: () => import('./MaleLt'),
  MaleMd: () => import('./MaleMd'),
  MeatballBd: () => import('./MeatballBd'),
  MeatballLt: () => import('./MeatballLt'),
  MeatballMd: () => import('./MeatballMd'),
  MessageOffBd: () => import('./MessageOffBd'),
  MessageOffLt: () => import('./MessageOffLt'),
  MessageOffMd: () => import('./MessageOffMd'),
  MessageOnBd: () => import('./MessageOnBd'),
  MessageOnLt: () => import('./MessageOnLt'),
  MessageOnMd: () => import('./MessageOnMd'),
  MinusBd: () => import('./MinusBd'),
  MinusLt: () => import('./MinusLt'),
  MinusMd: () => import('./MinusMd'),
  MissionOffBd: () => import('./MissionOffBd'),
  MissionOffLt: () => import('./MissionOffLt'),
  MissionOffMd: () => import('./MissionOffMd'),
  MissionOnBd: () => import('./MissionOnBd'),
  MissionOnLt: () => import('./MissionOnLt'),
  MissionOnMd: () => import('./MissionOnMd'),
  MobileAppFilled: () => import('./MobileAppFilled'),
  MobileFilled: () => import('./MobileFilled'),
  MobileWebFilled: () => import('./MobileWebFilled'),
  More: () => import('./More'),
  NewFilled: () => import('./NewFilled'),
  NoteBd: () => import('./NoteBd'),
  NoteLt: () => import('./NoteLt'),
  NoteMd: () => import('./NoteMd'),
  NoticeFilled: () => import('./NoticeFilled'),
  NoticeOffBd: () => import('./NoticeOffBd'),
  NoticeOffLt: () => import('./NoticeOffLt'),
  NoticeOffMd: () => import('./NoticeOffMd'),
  NoticeOnLt: () => import('./NoticeOnLt'),
  NoticeOnMd: () => import('./NoticeOnMd'),
  NoticeOnMd1: () => import('./NoticeOnMd1'),
  PaperBd: () => import('./PaperBd'),
  PaperLt: () => import('./PaperLt'),
  PaperMd: () => import('./PaperMd'),
  PauseFilled: () => import('./PauseFilled'),
  PcwebFilled: () => import('./PcwebFilled'),
  PenLt: () => import('./PenLt'),
  PenMd: () => import('./PenMd'),
  PiPexitFilled: () => import('./PiPexitFilled'),
  PickBd: () => import('./PickBd'),
  PickFilled: () => import('./PickFilled'),
  PickLt: () => import('./PickLt'),
  PickMd: () => import('./PickMd'),
  PickerArrowDownFilled: () => import('./PickerArrowDownFilled'),
  PickerArrowUpFilled: () => import('./PickerArrowUpFilled'),
  PinBd: () => import('./PinBd'),
  PinFilled: () => import('./PinFilled'),
  PinLt: () => import('./PinLt'),
  PinMd: () => import('./PinMd'),
  PlayFilled: () => import('./PlayFilled'),
  PlusBd: () => import('./PlusBd'),
  PlusLt: () => import('./PlusLt'),
  PlusMd: () => import('./PlusMd'),
  PointBd: () => import('./PointBd'),
  PointLt: () => import('./PointLt'),
  PointMd: () => import('./PointMd'),
  PoliceBd: () => import('./PoliceBd'),
  PoliceLt: () => import('./PoliceLt'),
  PoliceMd: () => import('./PoliceMd'),
  PositionBd: () => import('./PositionBd'),
  PositionLt: () => import('./PositionLt'),
  PositionMd: () => import('./PositionMd'),
  RankBd: () => import('./RankBd'),
  RankLt: () => import('./RankLt'),
  RankMd: () => import('./RankMd'),
  Ranking01: () => import('./Ranking01'),
  Ranking02: () => import('./Ranking02'),
  Ranking03: () => import('./Ranking03'),
  RankingBd: () => import('./RankingBd'),
  RankingFilled: () => import('./RankingFilled'),
  RankingLt: () => import('./RankingLt'),
  RankingMd: () => import('./RankingMd'),
  ReactionHeartBd: () => import('./ReactionHeartBd'),
  ReactionHeartLt: () => import('./ReactionHeartLt'),
  ReactionHeartMd: () => import('./ReactionHeartMd'),
  RefreshBd: () => import('./RefreshBd'),
  RefreshLt: () => import('./RefreshLt'),
  RefreshMd: () => import('./RefreshMd'),
  SaveBd: () => import('./SaveBd'),
  SaveLt: () => import('./SaveLt'),
  SaveMd: () => import('./SaveMd'),
  SearchBd: () => import('./SearchBd'),
  SearchLt: () => import('./SearchLt'),
  SearchMd: () => import('./SearchMd'),
  SettingBd: () => import('./SettingBd'),
  SettingFilled: () => import('./SettingFilled'),
  SettingLt: () => import('./SettingLt'),
  SettingMd: () => import('./SettingMd'),
  ShareBd: () => import('./ShareBd'),
  ShareLt: () => import('./ShareLt'),
  ShareMd: () => import('./ShareMd'),
  StopBd: () => import('./StopBd'),
  StopLt: () => import('./StopLt'),
  StopMd: () => import('./StopMd'),
  StoreBd: () => import('./StoreBd'),
  StoreLt: () => import('./StoreLt'),
  StoreMd: () => import('./StoreMd'),
  SubtitleBd: () => import('./SubtitleBd'),
  SubtitleFilled: () => import('./SubtitleFilled'),
  SubtitleLt: () => import('./SubtitleLt'),
  SubtitleMd: () => import('./SubtitleMd'),
  SubtitleOffFilled: () => import('./SubtitleOffFilled'),
  SubtitleOnFilled: () => import('./SubtitleOnFilled'),
  SubtitleSetFilled: () => import('./SubtitleSetFilled'),
  ThumbnailBd: () => import('./ThumbnailBd'),
  ThumbnailLt: () => import('./ThumbnailLt'),
  ThumbnailMd: () => import('./ThumbnailMd'),
  TimeBd: () => import('./TimeBd'),
  TimeFilled: () => import('./TimeFilled'),
  TimeLt: () => import('./TimeLt'),
  TimeLtFilled: () => import('./TimeLtFilled'),
  TimeMd: () => import('./TimeMd'),
  TooltipBd: () => import('./TooltipBd'),
  TooltipFilled: () => import('./TooltipFilled'),
  TooltipLt: () => import('./TooltipLt'),
  TooltipMd: () => import('./TooltipMd'),
  TranslateFilled: () => import('./TranslateFilled'),
  TuneBd: () => import('./TuneBd'),
  TuneLt: () => import('./TuneLt'),
  TuneMd: () => import('./TuneMd'),
  TypoBd: () => import('./TypoBd'),
  TypoLt: () => import('./TypoLt'),
  TypoMd: () => import('./TypoMd'),
  UserFanBd: () => import('./UserFanBd'),
  UserFanLt: () => import('./UserFanLt'),
  UserFanMd: () => import('./UserFanMd'),
  UserFilled: () => import('./UserFilled'),
  UserLt: () => import('./UserLt'),
  UserManagerBd: () => import('./UserManagerBd'),
  UserManagerLt: () => import('./UserManagerLt'),
  UserManagerMd: () => import('./UserManagerMd'),
  UserMd: () => import('./UserMd'),
  UserOffBd: () => import('./UserOffBd'),
  UserOffFilled: () => import('./UserOffFilled'),
  UserOffLt: () => import('./UserOffLt'),
  UserOffMd: () => import('./UserOffMd'),
  UserOnBd: () => import('./UserOnBd'),
  UserOnFilled: () => import('./UserOnFilled'),
  UserOnLt: () => import('./UserOnLt'),
  UserOnMd: () => import('./UserOnMd'),
  ViewFilled: () => import('./ViewFilled'),
  VolumeOffBd: () => import('./VolumeOffBd'),
  VolumeOffFilled: () => import('./VolumeOffFilled'),
  VolumeOffLt: () => import('./VolumeOffLt'),
  VolumeOffMd: () => import('./VolumeOffMd'),
  VolumeOnBd: () => import('./VolumeOnBd'),
  VolumeOnFilled: () => import('./VolumeOnFilled'),
  VolumeOnLt: () => import('./VolumeOnLt'),
  VolumeOnMd: () => import('./VolumeOnMd'),
  VoteFilled: () => import('./VoteFilled'),
  WarningFilled: () => import('./WarningFilled'),
  WarningFilled1: () => import('./WarningFilled1'),
  WebFilled: () => import('./WebFilled'),
} as const;

export type IconName = keyof typeof iconLoaders;
